import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Preload hero image
const preloadLink = document.createElement('link');
preloadLink.rel = 'preload';
preloadLink.as = 'image';
preloadLink.href = 'https://cdn.magicpatterns.com/uploads/tk7sT8DRhqDxSJzYEtz6TD/Imagen_referencia_trading_en_paz.png';
preloadLink.setAttribute('fetchpriority', 'high');
document.head.appendChild(preloadLink);
(function () {
  const w = window as any;
  if (w.fbq) return;
  const n: any = w.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  };
  if (!w._fbq) w._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [];
  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  document.head.appendChild(script);
  w.fbq('init', '855275007473565');
  w.fbq('track', 'PageView');
})();
render(<App data-id="element-834" />, document.getElementById('root'));